export default __webpack_public_path__ + "static/media/ACZINO.b62fab81.png";